<div class="attributes" fxLayoutAlign="start center" fxLayoutGap="5px">
  <app-attribute-pill
    *ngFor="let attribute of attributes"
    [attribute]="attribute"
    [selected]="selected[attribute.id] || allSelected"
    (toggle)="toggle.emit($event)">
  </app-attribute-pill>
  <ng-content></ng-content>
</div>
